
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shared-list",
      function () {
        return require("private-next-pages/shared-list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shared-list"])
      });
    }
  